// import { useTranslation } from 'react-i18next';

import 'react-toastify/dist/ReactToastify.css';
import { addLibCategoryform } from "../../../../hooks/apiAxios";
import SuccessErrorMsg from "../../../../utilities/SuccessErrorMsg";
import { ToastContainer, toast } from 'react-toastify';
import { useForm } from "react-hook-form";

export default function AddLibCategory() {
    // const { t } = useTranslation();
    const { register, handleSubmit, formState: { errors } } = useForm();


    async function onSubmit(data) {
        // setLoading(true);
        try {
            const response = await addLibCategoryform(data);
            if (response.data.isSuccess) {
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
                toast.success("تم إضافة التصنيف ..شكرا لك");
            } else {
                toast.warn("حدث خطأ ما، حاول مرة أخرى");
            }
        } catch (error) {
            console.error("Error during form submission: ", error);
            toast.error("حدث خطأ ما، تواصل مع الدعم");
        } finally {
            // setLoading(false);
        }
    }

    return (
        <div className="modal fade" id={`addLibCategory`} tabIndex="-1" aria-labelledby={`addLibCategoryLabel`} aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h6 className="modal-title" id={`addLibCategoryLabel`}>إضافة تصنيف</h6>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form
                            className='d-flex flex-column flex-md-row mx-auto text-start px-3 pb-4 align-items-center'
                            onSubmit={handleSubmit(onSubmit)}>
                            <div className="d-flex flex-column col-11 col-md ms-4 mb-5 my-md-5 gap-2">
                                {/* Input fields */}
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">اسم التصنيف عربي</span>
                                    <input
                                        className={`form-control ${errors.nameAr && "border border-danger"}`}
                                        type="text"
                                        {...register("nameAr", { required: true })}
                                    />
                                    {errors.nameAr && <p className='errors-msg'>الاسم مطلوب</p>}
                                </div>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">اسم التصنيف إنجليزي</span>
                                    <input
                                        className={`form-control ${errors.name && "border border-danger"}`}
                                        type="text"
                                        {...register("name", { required: true })}
                                    />
                                    {errors.name && <p className='errors-msg'>الاسم مطلوب</p>}
                                </div>
                            </div>
                            <button
                                className='btn-masar-sm btn-light-beige text-white col-2 me-3 mb-3 position-absolute bottom-0 end-0'
                                type="submit">
                                إضافة
                            </button>
                        </form>
                        <SuccessErrorMsg
                            ToastContainer={ToastContainer}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}